import React from "react";
import { ArrowDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheGrowthTiers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-growth-tiers" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-40 transition-colors duration-300">
      {}
      <div className="pointer-events-none absolute top-1/2 left-1/2 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/10 blur-[100px] md:h-[800px] md:w-[800px] md:bg-primary/5 md:blur-[120px]" />

      <div ref={ref} className={cn("container relative z-10 mx-auto flex flex-col items-center px-4 text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
        {}
        <Badge variant="outline" className="mb-6 border-primary/20 bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary uppercase tracking-wider shadow-[0_0_15px_var(--color-primary)]/20 backdrop-blur-sm">
          Pricing
        </Badge>

        {}
        <h1 className="font-sans text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl lg:text-7xl">
          Transparent <span className="text-primary">Growth Tiers</span>
        </h1>

        {}
        <p className="mx-auto mt-6 max-w-2xl text-lg text-muted-foreground md:text-xl">
          Simple, fixed-price packages designed to help your business grow. We
          believe in complete transparency—no hidden fees, no surprise costs,
          just professional results.
        </p>

        {}
        <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:justify-center">
          <Button asChild size="lg" className="h-12 rounded-full bg-primary px-8 text-base font-semibold text-primary-foreground shadow-[0_0_20px_var(--color-primary)]/30 hover:bg-primary/90 hover:shadow-[0_0_30px_var(--color-primary)]/50">
            <Link to="#packages">View Packages</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-12 rounded-full border-primary/20 bg-primary/5 px-8 text-base text-foreground hover:bg-primary/10 hover:text-primary transition-colors">
            <Link to="/ContactPage">Contact Us</Link>
          </Button>
        </div>

        {}
        <div className="absolute -bottom-32 left-1/2 -translate-x-1/2 animate-bounce text-muted-foreground/50 md:-bottom-40">
          <ArrowDown className="h-6 w-6" />
        </div>
      </div>
    </section>;
}